module.exports = {
      id: "slider-next-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#slider-next",
      toString: function () {
        return this.url;
      }
    }